import { useParams } from "react-router";
import { useDropsPageQuery } from "src/components/drops/DropsPage.generated";
import { DropsPageView } from "src/components/drops/DropsPageView";
import { useDocumentTitle } from "src/hooks/useDocumentTitle";
import { ProjectParams } from "src/routes/routesDef";
import { queryResult } from "src/utils";

export function ProjectDropsPage() {
  const { projectId } = useParams<ProjectParams>();
  useDocumentTitle("Project Drops");
  const query = useDropsPageQuery({ variables: { filter: { project: [projectId] }, entityId: projectId } });

  return queryResult(query, ({ drops }) => <DropsPageView drops={drops} />);
}
